var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27192 1.33983C7.36027 1.14298 7.63973 1.14298 7.72808 1.33982L8.93917 4.03823C9.19365 4.60521 9.72974 4.99471 10.3476 5.06152L13.2882 5.37948C13.5027 5.40268 13.5891 5.66847 13.4292 5.81332L11.2371 7.79899C10.7765 8.21622 10.5717 8.84643 10.6991 9.45471L11.4332 9.30097L10.6991 9.45471L11.3054 12.3496C11.3496 12.5608 11.1235 12.7251 10.9363 12.6177L8.37046 11.1466C7.83132 10.8374 7.16868 10.8374 6.62954 11.1466L4.06366 12.6177C3.87648 12.7251 3.65039 12.5608 3.69462 12.3496L4.3009 9.45471C4.4283 8.84643 4.22353 8.21622 3.76293 7.79899L1.57085 5.81332C1.41093 5.66847 1.4973 5.40268 1.71181 5.37948L4.65239 5.06152C5.27026 4.99471 5.80635 4.60522 6.06082 4.03823L7.27192 1.33983Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star.7bdc8844e09322c833e277699bcc194a.svg";